import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FerienFiltersService } from '@app/services/ferienhauser/ferieneFilters.service';
import { FerienHauserService } from '@app/services/ferienhauser/ferienHauser.service';
import { Observable, Subject } from 'rxjs';
import { debounceTime, filter, share, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FerienFIlters } from '@app/models/filtermodels/FerienFIlters';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { Partner } from '@app/models/partner/IPartner';

@Component({
    selector: 'clever-ferienhauserziel',
    templateUrl: './ferienhauserziel.component.html',
    styleUrls: ['./ferienhauserziel.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class FerienhauserzielComponent implements OnInit, OnDestroy {
    @Input() mode: string = '';
    protected readonly _destroy = new Subject<void>();

    mySearchControl = new FormControl();
    defaultdatas = [
        {
            title: 'Kroatien',
            trail: '',
            id: '5460aeaaa3139',
        },
        {
            title: 'Italien',
            trail: '',
            id: '5460aeae078f7',
        },
        {
            title: 'Deutschland',
            trail: '',
            id: '5460aecab790d',
        },
        {
            title: 'Spanien',
            trail: '',
            id: '5460aeae487f8',
        },
        {
            title: 'Schweiz',
            trail: '',
            id: '5460aea910151',
        },
        {
            title: 'Österreich',
            trail: '',
            id: '5460aeb0f32e5',
        },
        {
            title: 'Niederlande',
            trail: '',
            id: '5460aed303689',
        },
    ];

    searchCountry: Observable<any>;

    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    media: string = 'lg';
    origin: string = 'default';
    zielText: string = 'Reiseziel';
    partner: Partner;

    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected ferienHauserService: FerienHauserService,
        protected ferienFiltersService: FerienFiltersService,
        protected mediaObserver: BreakpointObserver,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        this.initMedia();
        this.initPartner();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.changeDetectorRef.detectChanges();
    }

    async initPartner() {
        this.guardService.getPartner$.pipe(
            takeUntil(this._destroy)
        ).subscribe((obj) => {
            if (obj?.partnerid?.length > 0) {
                this.partner = obj;
                this.initSearchTarget();
                this.initFilterSub();
            }
        });
    }

    async initFilterSub() {
        this.ferienFiltersService.getfilters$.pipe(
            takeUntil(this._destroy)
        ).subscribe((filter: FerienFIlters) => {
            if (filter?.reisezielResult?.title?.length > 0) {
                if (this.zielText !== filter.reisezielResult.title) {
                    this.zielText = filter.reisezielResult.title;
                }
            } else {
                this.zielText = 'Reiseziel';
            }
        });
    }

    detectPast(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        this.mySearchControl.setValue(' ', { emitEvent: true, emitViewToModelChange: true });
        this.changeDetectorRef.detectChanges();
        this.mySearchControl.setValue(ev.clipboardData.getData('text'), { emitEvent: true, emitViewToModelChange: true });
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy(): void {
        this._destroy.next();
        this._destroy.complete();
    }

    initSearchTarget() {
        this.initSearchChange();
        this.ferienFiltersService.getfilters$.pipe(
            takeUntil(this._destroy)
        ).subscribe(params => {
            if (params) {
                if (this.mySearchControl?.value !== params?.reisezielResult?.title && params?.reisezielResult?.title?.length > 0) {
                    this.mySearchControl.setValue(params.reisezielResult?.title);
                }
            }
        });
    }

    initSearchChange() {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(200),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );
        this.searchCountry = filterShare.pipe(
            switchMap(value => this.ferienHauserService.request({
                searchtarget: value,
                apikey:this.partner?.hometogo?.apikey,
                origin: this.partner?.hometogo?.origin,
            }, 'completion'))
        );
    }

    selectObj(option) {
        this.zielText = option.title;
        this.ferienFiltersService.reisezielResult({
            title: option.title,
            trail: option.trail,
            id: option.id
        });
        this.showModal = false;
    }



    openModal(ev): void {
        ev?.stopPropagation();
        this.mySearchControl.setValue('');
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev): void {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.mySearchControl.setValue('');
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal(): void {
        this.showModal = false;
        this.changeDetectorRef.detectChanges();
    }

    closeModalMobile(): void {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.changeDetectorRef.detectChanges();
    }

    zoomin(position: any): void {
        this.origin = position;
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.changeDetectorRef.detectChanges();
        });
    }

    clearText(): void {
        this.mySearchControl.setValue('');
        this.focus = false;
        this.changeDetectorRef.detectChanges();
        setTimeout(() => {
            this.focus = true;
            this.changeDetectorRef.detectChanges();
        }, 50);
    }
}
